// extracted by mini-css-extract-plugin
export default {"text":"Slide_text__b40TB","image__container":"Slide_image__container__4BF1D"};